import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { api_url } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeletePrompt from "../Components/common/DeletePrompt";
const AddOn = () => {
  // States
  const [heroImages, setHeroImages] = useState([]);
  const [heroPreviews, setHeroPreviews] = useState([]);
  const [heroUrls, setHeroUrls] = useState([""]);
  const [marqueeTexts, setMarqueeTexts] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerUrl, setBannerUrl] = useState("");
  const [hero, setHeroImg] = useState([]);
  const [getBannerApi, setBannerApi] = useState({});
  const admin_token = localStorage.getItem("admin_token");


  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [heroToDelete, setHeroToDelete] = useState(null);

  const fetchHeroData = async () => {
    try {
      const response = await axios.get(`${api_url}/hero`, {
        headers: {
          "Content-Type": "multipart/form-data ",

          Authorization: "Bearer " + localStorage.getItem("admin_token"),
        },
      });

      const data = response.data;
      setHeroImg(data.data);
    } catch (error) {
      console.error("Failed to fetch hero data:", error);
    }
  };

  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchHeroData();
  }, []);

  // Handlers
  const handleHeroImagesChange = (e) => {
    const files = Array.from(e.target.files);
    const validImages = [];
    const previews = [];

    const checkImage = (file) => {
      return new Promise((resolve) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
          if (img.width === 1440 && img.height === 273) {
            validImages.push(file);
            previews.push(objectUrl);
          } else {
            alert(`Image "${file.name}" must be exactly 1440 x 273 pixels.`);
            URL.revokeObjectURL(objectUrl);
          }
          resolve();
        };

        img.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(); // handle error silently
        };

        img.src = objectUrl;
      });
    };

    Promise.all(files.map(checkImage)).then(() => {
      setHeroImages(validImages);
      setHeroUrls(Array(validImages.length).fill(""));
      setHeroPreviews(previews);
    });
  };
  const removePreviewImage = (index) => {
    const updatedImages = [...heroImages];
    const updatedPreviews = [...heroPreviews];
    const updatedUrls = [...heroUrls];

    updatedImages.splice(index, 1);
    updatedPreviews.splice(index, 1);
    updatedUrls.splice(index, 1);

    setHeroImages(updatedImages);
    setHeroPreviews(updatedPreviews);
    setHeroUrls(updatedUrls);

    // Reset input if no images are left
    if (updatedImages.length === 0 && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleHeroUrlChange = (index, value) => {
    const updatedUrls = [...heroUrls];
    updatedUrls[index] = value;
    setHeroUrls(updatedUrls);
  };

  const handleMarqueeChange = (index, value) => {
    const updatedTexts = [...marqueeTexts];
    updatedTexts[index].text = value;
    setMarqueeTexts(updatedTexts);
  };

  const addMarqueeField = () =>
    setMarqueeTexts([...marqueeTexts, { id: null, text: "" }]);
  const deleteMarqueeField = (index) => {
    const updatedTexts = [...marqueeTexts];
    updatedTexts.splice(index, 1);
    setMarqueeTexts(updatedTexts);
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      if (img.width === 1440 && img.height === 273) {
        setBannerImage(file);
      } else {
        alert(
          "Recommended image dimensions for Hero section banner: 1440 × 273 pixels."
        );
        e.target.value = "";
        setBannerImage(null);
      }

      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  const handleBannerUrlChange = (e) => setBannerUrl(e.target.value);

  // Requests
  const uploadHeroImages = async () => {
    try {
      const heroFormData = new FormData();
      heroImages.forEach((image) => heroFormData.append("files", image));
      heroUrls.forEach((url) => heroFormData.append("url", url));

      await axios.post(`${api_url}/hero`, heroFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("admin_token"),
        },
      });

      toast.success("Hero images uploaded successfully!");
      fetchHeroData();

      setHeroImages([]);
      setHeroPreviews([]);
      setHeroUrls([""]);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (error) {
      toast.error("Failed to upload hero images.");
    }
  };

  const deleteHeroBanner = async (hero_id) => {
    try {
      await axios.delete(`${api_url}/hero/${hero_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + admin_token,
        },
      });
      toast.success("Deleted Successfully");
      fetchHeroData();
    } catch (e) {
      toast.error("Error in deleting data");
    }
  };

  // UI
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-10">
          <ToastContainer />
      {/* Hero Section */}
      <section className="p-4 bg-white shadow rounded">
        <h2 className="text-xl font-semibold mb-4">
          Upload Hero Section Images
        </h2>

        {/* File Upload */}
        <input
          type="file"
          multiple
          ref={fileInputRef}
          onChange={handleHeroImagesChange}
          // onChange={handleHeroImagesChange}
          className="block w-full p-2 border rounded mb-4"
        />
        {/* Image Previews with Remove Buttons */}
        <div className="flex flex-wrap gap-4 mt-4">
          {heroPreviews.map((preview, index) => (
            <div
              key={index}
              className="relative w-full h-full border rounded overflow-hidden group"
            >
              <img
                src={preview}
                alt={`Preview ${index}`}
                className="object-cover w-full h-full"
              />
              <button
                onClick={() => removePreviewImage(index)}
                className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-bl hover:bg-red-600"
                title="Remove"
              >
                ✕
              </button>
            </div>
          ))}
        </div>

        {/* URL Inputs for Hero Images */}
        {heroImages.map((_, index) => (
          <input
            key={index}
            type="text"
            placeholder="Enter Image URL"
            value={heroUrls[index] || ""}
            onChange={(e) => handleHeroUrlChange(index, e.target.value)}
            className="block w-full p-2 border rounded mb-4"
          />
        ))}

        {/* Upload Button */}
        <button
          onClick={uploadHeroImages}
          className="bg-[#3C1F1F] hover:bg-blue-600 text-white py-2 px-4 rounded"
        >
          Upload Hero Images
        </button>

        {/* Display Uploaded Hero Images */}
        <div className="py-2 flex gap-2 flex-wrap">
          {hero.map((img, ind) => (
            <div key={ind} className="border p-3">
              <img
                src={img.image}
                alt=""
                className="h-[100px] object-contain"
              />
              {/* Display Image URL */}
              <a
                href={img.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline block mt-2"
              >
                {img.url}
              </a>
              {/* Delete Button */}
              <button
                className="bg-[#3C1F1F] font-semibold px-4 text-xs py-2 mt-2 rounded-md text-white hover:bg-red-500 hover:text-white"
                onClick={() => {
                  setHeroToDelete(img.hero_id);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </section>
  
      <DeletePrompt
        showModal={showDeleteModal}
        onDelete={() => {
          if (heroToDelete) {
            deleteHeroBanner(heroToDelete);
            setHeroToDelete(null);
          }
          setShowDeleteModal(false);
        }}
        onCancel={() => {
          setShowDeleteModal(false);
          setHeroToDelete(null);
        }}
      />
    </div>
  );
};
  export default AddOn;
